/** M-WF-01 · Compilazione applicata: sola lettura, chi/quando, cronologia revisioni, confronto e riapertura. */
import React from "react";
import { CheckCircle2, GitCompare, History, RotateCcw } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { SuiteButton } from "@/components/suite";
import { formatDateTimeIT } from "@/foundation/formatting";

const STATUS = { draft: "Bozza", confirmed: "Verificata", applied: "Applicata" };

function RevisionHistory({ revisions }) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <SuiteButton size="sm" variant="ghost" icon={History} data-testid="timesheet-history-btn">Cronologia ({revisions.length})</SuiteButton>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-[340px] p-2" data-testid="timesheet-history">
        <ul className="space-y-1 text-xs">
          {[...revisions].reverse().map((r) => (
            <li key={r.id} className="flex items-start justify-between gap-2 rounded px-2 py-1.5 hover:bg-suite-neutral-50" data-testid={`timesheet-history-v${r.revision}`}>
              <span><b className="font-mono">v{r.revision}</b> · {STATUS[r.status] || r.status}{r.parent_id ? " (riaperta)" : ""}</span>
              <span className="text-right text-suite-neutral-500">
                {r.status === "applied" ? <>da {r.applied_by_name || "—"}<br />{formatDateTimeIT(r.applied_at)}</> : <>da {r.created_by_name || "—"}<br />{formatDateTimeIT(r.created_at)}</>}
              </span>
            </li>
          ))}
        </ul>
      </PopoverContent>
    </Popover>
  );
}

export function TimesheetAppliedBanner({ applied, revisions, readOnly, onCompare, onReopen, reopening }) {
  const c = applied.counts || {};
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 rounded-lg border border-emerald-200 bg-emerald-50/60 px-4 py-3" data-testid="timesheet-applied-banner">
      <div className="flex items-start gap-3">
        <CheckCircle2 className="mt-0.5 text-emerald-600" size={18} />
        <div className="text-sm">
          <div className="font-semibold text-emerald-900" data-testid="timesheet-applied-title">Applicata al Cartellino · v{applied.revision}</div>
          <div className="text-xs text-emerald-800" data-testid="timesheet-applied-meta">
            da {applied.applied_by_name || "—"} il {formatDateTimeIT(applied.applied_at)} · {c.update || 0} aggiornate · {(c.keep || 0) + (c.skip || 0)} invariate{c.protected ? ` · ${c.protected} protette` : ""}
          </div>
        </div>
      </div>
      <div className="flex flex-wrap items-center gap-1.5">
        <RevisionHistory revisions={revisions} />
        <SuiteButton size="sm" variant="secondary" icon={GitCompare} onClick={onCompare} data-testid="timesheet-compare-btn">Confronta con Cartellino</SuiteButton>
        {!readOnly && <SuiteButton size="sm" icon={RotateCcw} loading={reopening} onClick={onReopen} data-testid="timesheet-reopen-btn">Riapri (v{applied.revision + 1})</SuiteButton>}
      </div>
    </div>
  );
}

export { RevisionHistory };
export default TimesheetAppliedBanner;
